export const epochToString = (epoch) => {
    if (epoch) {
        const dateVal = new Date(parseInt(epoch) * 1000)
        const day = dateVal.getDate().toString().padStart(2, "0");
        const month = (1 + dateVal.getMonth()).toString().padStart(2, "0");
        const hour = dateVal.getHours().toString().padStart(2, "0");
        const minute = dateVal.getMinutes().toString().padStart(2, "0");
        const inputDate = dateVal.getFullYear() + "-" + (month) + "-" + (day) + "T" + (hour) + ":" + (minute)
        return inputDate
    } else {
        return ""
    }
}

export const epochToStringNoT = (epoch) => {
    if (epoch) {
        const dateVal = new Date(parseInt(epoch) * 1000)
        const day = dateVal.getDate().toString().padStart(2, "0");
        const month = (1 + dateVal.getMonth()).toString().padStart(2, "0");
        const hour = dateVal.getHours().toString().padStart(2, "0");
        const minute = dateVal.getMinutes().toString().padStart(2, "0");
        const inputDate = dateVal.getFullYear() + "-" + (month) + "-" + (day) + " " + (hour) + ":" + (minute) 
        return inputDate
    } else {
        return ""
    }
}

export const epochToDateString = (epoch) => {
    if (epoch) {
        const dateVal = new Date(parseInt(epoch) * 1000)
        const day = dateVal.getDate().toString().padStart(2, "0");
        const month = (1 + dateVal.getMonth()).toString().padStart(2, "0");
        const inputDate = dateVal.getFullYear() + "-" + (month) + "-" + (day)
        return inputDate
    } else {
        return ""
    }
}



export const epochToUTCDate = (epoch) => {
    if (epoch) {
        const dateVal = new Date(parseInt(epoch) * 1000)
        const day = dateVal.getUTCDate().toString().padStart(2, "0");
        const month = (1 + dateVal.getUTCMonth()).toString().padStart(2, "0");
        const inputDate = dateVal.getUTCFullYear() + "-" + (month) + "-" + (day)
        return inputDate
    } else {
        return ""
    }
}

export const getDatesInRange = (startDate, endDate) => {
    // gets a range of dates in YYYY-MM format between start and end dates including those dates
    const [startYear, startMonth] = startDate.split("-").map(Number);
    const [endYear, endMonth] = endDate.split("-").map(Number);
    const dates = [];

    for (let year = startYear; year <= endYear; year++) {
        const start = year === startYear ? startMonth : 1;
        const end = year === endYear ? endMonth : 12;
        for (let month = start; month <= end; month++) {
            const monthStr = month.toString().padStart(2, '0');
            dates.push(`${year}-${monthStr}`);
        }
    }

    return dates;
}


// DD-MM-YYYY format with default parameter
export const getCurrentFormattedDate = (date = new Date()) => {
    const today = new Date(date);
    const day = today.getDate().toString().padStart(2, "0");
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const year = today.getFullYear();
    return `${day}-${month}-${year}`;
};